import React from "react";

export const MatchOptions = {
  footballLiveStatuses: [
    "inprogress",
    "1st half",
    "2nd half",
    "half time",
    "et 2nd half",
    "et 1st half",
    "penalty",
  ],
  footballFTStatuses: ["finished", "finished ap", "finished aet"],
  basketballLiveStatuses: [
    "q1",
    "q2",
    "q3",
    "q4",
    "q5",
    "inprogress",
    "1st Innings",
    "2nd Innings",
  ],
};

// export default MatchOptions;

export const currentCount = () =>
  Number(document.querySelector(".nav-tabs .active .count")?.textContent);


export const isFinishedMatch = (match) =>
  [
    "finished",
    "finished ap",
    "finished aet",
    "awarded",
    "cancelled",
    "postponed",
    "abandoned",
    "deleted",
    "result only",
    "stumps",
  ]?.includes(match?.st?.toLowerCase() || match?.bs?.toLowerCase());